<div class="collapse" [ngbCollapse]="collapse_education" id="dateposted">
  <div class="bg-light p-3 mt-4">
    <form class="form-row" [formGroup]="form">
      <div class="form-group col-md-6">
        <label>Education Level</label>
        <select class="form-control basic-select" formControlName="educationLevel">
          <option *ngFor="let educationLevel of lookupStore.educationLevels | async" [ngValue]="educationLevel.id">{{educationLevel.value}}</option>
        </select>
      </div>
      <div class="form-group col-md-6">
        <label>Subject</label>
        <input type="text" class="form-control" formControlName="subject">
      </div>
      <div class="form-group col-md-6 select-border">
        <label>Year</label>
        <select class="form-control basic-select" formControlName="year">
          <option *ngFor="let year of years" [ngValue]="year">{{year}}</option>
        </select>
      </div>
      <div class="form-group col-md-6">
        <label>Institute</label>
        <input type="text" class="form-control" formControlName="institute">
      </div>
      <div class="form-group col-md-12">
        <label>Description</label>
        <textarea class="form-control" rows="4" formControlName="description"></textarea>
      </div>
      <div class="form-group col-md-12 mb-0">
        <a class="btn btn-md btn-primary" [routerLink]="" (click)="save()">{{this.buttonText}}</a>
      </div>
    </form>
  </div>
</div>